import { CTab } from './CTab.js';
import { CTabContent } from './CTabContent.js';
import { CTabList } from './CTabList.js';
import { CTabPane } from './CTabPane.js';
import { CTabPanel } from './CTabPanel.js';
import { CTabs } from './CTabs.js';

const CTabsPlugin = {
    install: (app) => {
        app.component(CTab.name, CTab);
        app.component(CTabContent.name, CTabContent);
        app.component(CTabList.name, CTabList);
        app.component(CTabPane.name, CTabPane);
        app.component(CTabPanel.name, CTabPanel);
        app.component(CTabs.name, CTabs);
    },
};

export { CTab, CTabContent, CTabList, CTabPane, CTabPanel, CTabs, CTabsPlugin };
//# sourceMappingURL=index.js.map
